/**
 * Show/hide password toggles — extracted verbatim (behaviour-preserving) from the
 * Hyper theme's hyper.js `initShowHidePassword`, the only live piece of that file.
 * (DDT-3772 — drop Hyper JS.)
 *
 * Each toggle sits next to its input and flips it between password/text. Three
 * variants are used across the templates, differing only in how the input is
 * located relative to the toggle:
 *   - [data-password]               → sibling <input>
 *   - [data-password-account-reset] → sibling <div> > <input>
 *   - [data-password-login-reset]   → sibling <input>
 */
import $ from 'jquery';

(function () {
    if (window.__ddPasswordToggleInit) return;
    window.__ddPasswordToggleInit = true;

    function bind() {
        $(document).on('click', '[data-password]', function () {
            const $btn = $(this);
            if ($btn.attr('data-password') === 'false') {
                $btn.siblings('input').attr('type', 'text');
                $btn.attr('data-password', 'true').addClass('show-password');
            } else {
                $btn.siblings('input').attr('type', 'password');
                $btn.attr('data-password', 'false').removeClass('show-password');
            }
        });

        $(document).on('click', '[data-password-account-reset]', function () {
            const $btn = $(this);
            if ($btn.attr('data-password-account-reset') === 'false') {
                $btn.siblings('div').find('input').attr('type', 'text');
                $btn.attr('data-password-account-reset', 'true').addClass('show-password');
            } else {
                $btn.siblings('div').find('input').attr('type', 'password');
                $btn.attr('data-password-account-reset', 'false').removeClass('show-password');
            }
        });

        $(document).on('click', '[data-password-login-reset]', function () {
            const $btn = $(this);
            if ($btn.attr('data-password-login-reset') === 'false') {
                $btn.siblings('input').attr('type', 'text');
                $btn.attr('data-password-login-reset', 'true').addClass('show-password');
            } else {
                $btn.siblings('input').attr('type', 'password');
                $btn.attr('data-password-login-reset', 'false').removeClass('show-password');
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bind);
    } else {
        bind();
    }
})();
